import { FC } from 'react';

import { IconProps } from './types';

export const SnowflakeIcon: FC<IconProps> = ({
	color = '#06519E',
	height = 24,
	size,
	width = 24,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			d="M10.909 22.909c0 .6034.4888 1.091 1.091 1.091s1.091-.4876 1.091-1.091v-3.912l2.5014 2.5015a1.088 1.088 0 0 0 .7712.3197c.2793 0 .5586-.107.7713-.3197a1.0897 1.0897 0 0 0 0-1.5425l-4.044-4.044v-2.821h2.8211l4.044 4.044a1.088 1.088 0 0 0 .7713.3195c.2792 0 .5585-.1069.7712-.3196a1.0897 1.0897 0 0 0 0-1.5425l-2.5014-2.5015h3.912C23.5124 13.091 24 12.6022 24 12s-.4876-1.091-1.091-1.091h-3.912l2.5015-2.5014a1.0897 1.0897 0 0 0 0-1.5425 1.0897 1.0897 0 0 0-1.5425 0l-4.044 4.044h-2.821V8.088l4.044-4.044a1.0897 1.0897 0 0 0 0-1.5425 1.0897 1.0897 0 0 0-1.5426 0l-2.5015 2.5014V1.091C13.091.4887 12.6022 0 12 0s-1.091.4887-1.091 1.091v3.912L8.4077 2.5014a1.0897 1.0897 0 0 0-1.5425 0 1.0897 1.0897 0 0 0 0 1.5425l4.044 4.044v2.821H8.088L4.044 6.865a1.0897 1.0897 0 0 0-1.5425 0 1.0897 1.0897 0 0 0 0 1.5426l2.5014 2.5015H1.091C.4887 10.909 0 11.3978 0 12s.4887 1.091 1.091 1.091h3.912l-2.5015 2.5014a1.0897 1.0897 0 0 0 0 1.5425 1.088 1.088 0 0 0 .7712.3196c.2793 0 .5586-.1069.7713-.3196l4.044-4.044h2.821v2.8211l-4.044 4.044a1.0897 1.0897 0 0 0 0 1.5425 1.0897 1.0897 0 0 0 1.5426 0l2.5015-2.5014v3.912Z"
			fillRule="evenodd"
		/>
	</svg>
);
